import { handleActions } from 'redux-actions'
import * as rawActions from '../actions'

const defaultState = false

export default handleActions(
  {
    [rawActions.openClassificationAnnotationsTimeline](state, action) {
      return true
    },
    [rawActions.closeClassificationAnnotationsTimeline](state, action) {
      return false
    },
    [rawActions.resetState](state, action) {
      return defaultState
    },
  },
  defaultState
)
